// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import GoogleMapReact from 'google-map-react'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import MapMarker from 'components/Map/MapMarker'
import { loop } from 'utilities/objects'
import { loopArray } from 'utilities/arrays'
import { getTimeFrom2400Hours, getWeekday } from 'utilities/time'
import IconMinus from 'components/svg/map/minus-square-outline.svg'
import IconPlus from 'components/svg/map/plus-square-outline.svg'

// Redux:
import * as siteActions from 'actions/site'

function mapOptions( maps ) {
	return {
		styles: [{ 'featureType':'administrative', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#6195a0' }] }, { 'featureType':'administrative.province', 'elementType':'geometry.stroke', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'landscape', 'elementType':'geometry', 'stylers':[{ 'lightness':'0' }, { 'saturation':'0' }, { 'color':'#f5f5f2' }, { 'gamma':'1' }] }, { 'featureType':'landscape.man_made', 'elementType':'all', 'stylers':[{ 'lightness':'-3' }, { 'gamma':'1.00' }] }, { 'featureType':'landscape.natural.terrain', 'elementType':'all', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'poi', 'elementType':'all', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'poi.park', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#bae5ce' }, { 'visibility':'on' }] }, { 'featureType':'road', 'elementType':'all', 'stylers':[{ 'saturation':-100 }, { 'lightness':45 }, { 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'all', 'stylers':[{ 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#fac9a9' }, { 'visibility':'simplified' }] }, { 'featureType':'road.highway', 'elementType':'labels.text', 'stylers':[{ 'color':'#4e4e4e' }] }, { 'featureType':'road.arterial', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#787878' }] }, { 'featureType':'road.arterial', 'elementType':'labels.icon', 'stylers':[{ 'visibility':'off' }] }, { 'featureType':'transit', 'elementType':'all', 'stylers':[{ 'visibility':'simplified' }] }, { 'featureType':'transit.station.airport', 'elementType':'labels.icon', 'stylers':[{ 'hue':'#0a00ff' }, { 'saturation':'-77' }, { 'gamma':'0.57' }, { 'lightness':'0' }] }, { 'featureType':'transit.station.rail', 'elementType':'labels.text.fill', 'stylers':[{ 'color':'#43321e' }] }, { 'featureType':'transit.station.rail', 'elementType':'labels.icon', 'stylers':[{ 'hue':'#ff6c00' }, { 'lightness':'4' }, { 'gamma':'0.75' }, { 'saturation':'-68' }] }, { 'featureType':'water', 'elementType':'all', 'stylers':[{ 'color':'#eaf6f8' }, { 'visibility':'on' }] }, { 'featureType':'water', 'elementType':'geometry.fill', 'stylers':[{ 'color':'#c7eced' }] }, { 'featureType':'water', 'elementType':'labels.text.fill', 'stylers':[{ 'lightness':'-49' }, { 'saturation':'-53' }, { 'gamma':'0.79' }] }],
		scrollwheel: false,
		gestureHandling: 'cooperative',
		fullscreenControl: false,
		zoomControl: false,
		disableDefaultUI: window.innerWidth > siteData.mobile_max_width ? false : true
	}
}

class LocationsMap extends React.Component {
	constructor() {
		super()

		this.state = {
			hoveredMarker: false,
			selectedMarker: false,
			closestMarker: false,
			zoom: 4
		}
		this.mapObject = false
		this.allowMapOverride = true
		this.refSelected = React.createRef()
	}

	componentDidMount() {
		const { dispatch, userLocation } = this.props

		dispatch( siteActions.getLocationsData() )

		if ( ! userLocation ) {
			dispatch( siteActions.requestCurrentPosition() )
		}

		zenscroll.setup( 400, 200 )
	}

	componentDidUpdate( prevProps ) {
		const { locationsCloseToLocation } = this.props

		if ( locationsCloseToLocation && ! prevProps.locationsCloseToLocation ) {
			// Allow time for map to load:
			setTimeout( () => {
				this.checkLocation()
			}, 1000 )
		}
	}

	checkLocation = () => {
		const { locationsCloseToLocation } = this.props

		if ( this.mapObject && this.allowMapOverride ) {
			if ( locationsCloseToLocation && locationsCloseToLocation[0] ) {
				this.mapObject.setZoom( 11 )
				this.mapObject.setCenter( {
					lat: locationsCloseToLocation[0].lat,
					lng: locationsCloseToLocation[0].lng
				} )

				this.setState( {
					hoveredMarker: locationsCloseToLocation[0],
					selectedMarker: locationsCloseToLocation[0],
					closestMarker: locationsCloseToLocation[0],
					zoom: 11
				} )
			}
		}
	}

	handleApiLoaded = ( map ) => {
		this.mapObject = map.map

		this.mapObject.addListener( 'dragstart', () => {
			this.allowMapOverride = false
		} )

		this.mapObject.addListener( 'zoom_changed', () => {
			this.allowMapOverride = false
		} )
	}

	handleMarkerHover = ( markerData, e ) => {
		this.setState( {
			hoveredMarker: markerData
		} )
	}

	handleMarkerClick = ( markerData, e ) => {
		this.setState( {
			selectedMarker: markerData
		} )
	}

	handleListItemClick = ( markerData, e ) => {
		this.setState( {
			selectedMarker: markerData
		} )

		this.mapObject.setCenter( {
			lat: markerData.lat,
			lng: markerData.lng
		} )

		if ( this.refSelected ) {
			zenscroll.to( this.refSelected.current )
		}
	}

	handleMapClick = () => {
		const { dispatch, isMobile } = this.props

		if ( isMobile ) {
			this.setState( {
				hoveredMarker: false,
				selectedMarker: false
			} )
		}
	}

	handleSelectedMoreClick = () => {

	}

	handleZoomIn = () => {
		this.setState( {
			zoom: this.state.zoom + 1
		} )
	}

	handleZoomOut = () => {
		this.setState( {
			zoom: this.state.zoom - 1
		} )
	}

	renderSelected = () => {
		const { selectedMarker } = this.state

		if ( ! selectedMarker ) {
			return null
		}

		var addressParts = []
		if ( selectedMarker.city ) addressParts.push( selectedMarker.city )
		if ( selectedMarker.region ) addressParts.push( selectedMarker.region )
		if ( selectedMarker.country ) addressParts.push( selectedMarker.country )
		const addressLine2 = addressParts.join( ', ' )

		const directionFull = selectedMarker.street_address + ', ' + selectedMarker.city + ', ' + selectedMarker.region + ', ' + selectedMarker.country
		const directionUrlPart = directionFull.replace( / /g, '+' )

		var timesMarkup = false
		var showTimes = false
		var languagesMarkup = false
		var showLanguages = false
		var clubsMarkup = false
		var showClubs = false

		if ( selectedMarker && selectedMarker.times && selectedMarker.times.length ) {
			showTimes = true

			timesMarkup = selectedMarker.times.map( ( e, i ) => {
				const day = getWeekday( e.day_of_week )
				const startTime = getTimeFrom2400Hours( e.start_time )

				return (
					<div className="-info" key={ i }>
						<div>
							<p className="-heading">{ day + ' ' + startTime }</p>
							<p dangerouslySetInnerHTML={ { __html: e.name } }></p>
						</div>
					</div>
				)
			} )
		}

		if ( selectedMarker && selectedMarker.languages && selectedMarker.languages.length ) {
			showLanguages = true

			languagesMarkup = selectedMarker.languages.map( ( e, i ) => {
				return (
					<span key={ i }>{ e }</span>
				)
			} )
		}

		if ( selectedMarker && selectedMarker.clubs && selectedMarker.clubs.length ) {
			showClubs = true

			clubsMarkup = selectedMarker.clubs.map( ( e, i ) => {
				return (
					<span key={ i }>{ e }</span>
				)
			} )
		}

		return (
			<div className="-selected">
				<div className="-featured">
					<p className="-most-relevant">
						<a href={ selectedMarker.site_url } target="_blank" rel="noopener" dangerouslySetInnerHTML={ { __html: selectedMarker.title } } />
					</p>

					<div className="-secondary">
						<span dangerouslySetInnerHTML={ { __html: selectedMarker.street_address } }></span>
						<span dangerouslySetInnerHTML={ { __html: addressLine2 } }></span>
						<span className="-directions-link"><a href={ 'https://www.google.com/maps/dir/Current+Location/' + directionUrlPart } target="_blank" rel="noopener">Directions</a></span>

						<div className="-more" onClick={ this.handleSelectedMoreClick }>
							<i className="fa fa-angle-up" aria-hidden="true"></i>
						</div>
					</div>
				</div>

				<div className="-church-details">
					{ selectedMarker.image_url &&
						<a href={ selectedMarker.site_url } className="-image">
							<img src={ selectedMarker.image_url } alt="" />
						</a>
					}

					<div className="-text -text-a">
						{ timesMarkup }
					</div>

					<div className="-text -text-b">
						{ showLanguages &&
							<div className="-info -language-info">
								<i className="icon fa fa-language" aria-hidden="true"></i>

								<div>{ languagesMarkup }</div>
							</div>
						}

						{ showClubs &&
							<div className="-info -clubs-info">
								<i className="icon icon-campsite" aria-hidden="true"></i>

								<div>{ clubsMarkup }</div>
							</div>
						}
					</div>
				</div>
			</div>
		)
	}

	render() {
		const { locationsById, locationsCloseToLocation, userLocation } = this.props
		const { hoveredMarker, selectedMarker, zoom } = this.state
		let center = {
			lat: -29.2892123,
			lng: 139
		}
		let defaultZoom = 4

		if ( locationsCloseToLocation && locationsCloseToLocation[0] ) {
			defaultZoom = 11
			center = {
				lat: locationsCloseToLocation[0].lat,
				lng: locationsCloseToLocation[0].lng
			}
		}

		let markersMarkup = [],
			listMarkup = {
				'act': [],
				'nsw': [],
				'nt': [],
				'qld': [],
				'sa': [],
				'tas': [],
				'vic': [],
				'wa': [],
			}

		if ( locationsById ) {
			markersMarkup = Object.keys( locationsById ).map( ( key ) => {
				let item = locationsById[ key ]

				return (
					<MapMarker
						key={ key }
						lat={ item.lat }
						lng={ item.lng }
						selectedMarker={ selectedMarker }
						onClick={ this.handleMarkerClick.bind( this, item ) }
						onMouseOver={ this.handleMarkerHover.bind( this, item ) }
					/>
				)
			} )

			let locationsSorted = Object.keys( locationsById ).map( ( key ) => {
				return locationsById[ key ]
			} )

			locationsSorted.sort( ( a, b ) => {
			    if ( a.title < b.title ) {
			    	return -1
			    }

			    if ( a.title > b.title ) {
			    	return 1
			    }

			    return 0
			} )

			locationsSorted.map( ( item ) => {
				if ( item.region ) {
					listMarkup[ item.region.toLowerCase() ].push(
						<div className="-item" key={ item.title } onClick={ this.handleListItemClick.bind( this, item ) }>
							<div className="-name">{ item.title }</div>
						</div>
					)
				}
			} )
		}

		let statesListMarkup = []
		let statesListFirst = []
		let statesListRest = [
			{
				id: 'act',
				name: 'ACT'
			},
			{
				id: 'nsw',
				name: 'New South Wales'
			},
			{
				id: 'nt',
				name: 'Northern Territory'
			},
			{
				id: 'qld',
				name: 'Queensland'
			},
			{
				id: 'sa',
				name: 'South Australia'
			},
			{
				id: 'tas',
				name: 'Tasmania'
			},
			{
				id: 'vic',
				name: 'Victoria'
			},
			{
				id: 'wa',
				name: 'Western Australia'
			}
		]

		if ( userLocation && userLocation.states && userLocation.states.length ) {
			loopArray( userLocation.states, ( key, item ) => {
				statesListFirst.push( item )

				statesListRest = statesListRest.filter( e => e.id != item.id )
			} )
		}

		loopArray( statesListFirst, ( key, item ) => {
			if ( ! listMarkup[ item.id ] || ! listMarkup[ item.id ].length ) {
				return
			}

			statesListMarkup.push(
				<section key={ item.id }>
					<header>
						<p>{ item.name }</p>
					</header>

					<main>
						{ listMarkup[ item.id ] }
					</main>
				</section>
			)
		} )

		loopArray( statesListRest, ( key, item ) => {
			if ( ! listMarkup[ item.id ] || ! listMarkup[ item.id ].length ) {
				return
			}

			statesListMarkup.push(
				<section key={ item.id }>
					<header>
						<p>{ item.name }</p>
					</header>

					<main>
						{ listMarkup[ item.id ] }
					</main>
				</section>
			)
		} )

		return (
			<div className="locations-wrap" ref={ this.refSelected }>
				<div className="-map">
					<div className="-controls">
						<div className="-zoom">
							<div className="-zoom-in" onClick={ this.handleZoomOut }><IconMinus /></div>
							<div className="-zoom-out" onClick={ this.handleZoomIn }><IconPlus /></div>
						</div>
					</div>

					<div className="-inner">
						{ hoveredMarker &&
							<div className="-info-box is-visible" onClick={ this.handleMarkerClick.bind( this, hoveredMarker ) }>
								<div className="-text">
									<p className="-title" dangerouslySetInnerHTML={ { __html: hoveredMarker.title } }></p>

									{ hoveredMarker.address &&
										<p className="-address" dangerouslySetInnerHTML={ { __html: hoveredMarker.address } }></p>
									}

									<p className="-more-info">Click for more info</p>
								</div>
							</div>
						}

						<div className="-map-frame">
							<GoogleMapReact
								bootstrapURLKeys={ {
									key: siteData.google_maps_api_key
								} }
								resetBoundsOnResize
								defaultCenter={ center }
								defaultZoom={ defaultZoom }
								zoom={ zoom }
								options={ mapOptions }
								onClick={ this.handleMapClick }
								onGoogleApiLoaded={ this.handleApiLoaded }
								yesIWantToUseGoogleMapApiInternals
							>
								{ markersMarkup }
							</GoogleMapReact>
						</div>
					</div>
				</div>

				<div className="-selected-wrap">
					<div className="-text">
						<h2>Find a club close to you</h2>
					</div>

					{ this.renderSelected() }
				</div>

				<div className="-list">
					<div className="-inner">
						{ statesListMarkup }
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		isMobile: state.site.isMobile,
		userLocation: state.site.userLocation,
		locationsById: state.site.locationsById,
		locationsCloseToLocation: state.site.locationsCloseToLocation
	}
}

export default connect( mapStateToProps )( LocationsMap )



// WEBPACK FOOTER //
// ./components/LocationsMap/LocationsMap.jsx